import { createSlice } from '@reduxjs/toolkit'

import { fetchPrices_aggregated } from '../requests/thunks'

interface BundleState {
  errors: any[] | null
  articles: any[] | null
  summary: Record<PropertyKey, any> | null
  articlesTotal: number | null
  _latestPendingRequestId: string
}

const initialState: BundleState = {
  errors: null, // []
  articles: null, // []
  summary: null, // {}
  articlesTotal: null, // int
  _latestPendingRequestId: '',
}

const bundleSlice = createSlice({
  name: 'bundle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrices_aggregated.pending, (state, action) => {
        state._latestPendingRequestId = action.meta.requestId
      })
      .addCase(fetchPrices_aggregated.fulfilled, (state, action) => {
        if (state._latestPendingRequestId === action.meta.requestId) {
          const {
            bundle: { errors, articles, summary },
          } = action.payload

          if (errors) {
            console.error('Received errors from pricehelper API: ', JSON.stringify(errors, null, 2))
            state.errors = errors
          } else {
            state.errors = null
          }

          state.articles = articles
          state.summary = summary
          state.articlesTotal = articles
            .map(({ Quantity }: any) => Quantity)
            .reduce((total: number, Quantity: number) => total + Quantity, 0)
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was fulfilled for deprecated DM 'configuration-update' event -- payload is ignored."
          )
        }
      })
      .addCase(fetchPrices_aggregated.rejected, (state, action) => {
        if (state._latestPendingRequestId === action.meta.requestId) {
          state.errors = null
          state.articles = null
          state.summary = null
        } else if (import.meta.env.VITE_SCENSUM_ENV !== 'production') {
          console.log(
            "mok-context-spa in dev/test env: fetchPrices_aggregated was rejected for deprecated DM 'configuration-update' event."
          )
        }
      })
  },
})

export default bundleSlice.reducer
